<template>
  <div class="fts-user">
    <!-- <pre>
      formData.{{item.fieldName}}: {{formData[item.fieldName]}}
      formData.{{item.fieldName}}Id: {{formData[`${item.fieldName}Id`]}}
      formData.{{item.fieldName}}Username: {{formData[`${item.fieldName}Username`]}}
      [item]   allowOther: {{item.allowOther}}
      [item]   canAddNew: {{item.canAddNew}}
      [item]   type: {{item.type}}
    </pre> -->
    <v-select
      :append-to-body="appendToBody"
      :label="label"
      :options="list"
      :searchable="!item.optionList"
      :filterable="true"
      :filter-by="isFilterKeys ? filterByKeys : filterBy"
      :multiple="multiple"
      :text="formData[item.fieldName]"
      :reduce="getReduce"
      :reduceKey="getReduceKey"
      :getOptionLabelKey="getOptionLabelKey"
      max-height="200px"
      :placeholder="multiple ? 'Please select' : 'Please select one'"
      v-model="formData[item.fieldName]"
      :inputId="inputId"
      :can-add-new="item.canAddNew"
      :connection-id="item.connectionId"
      :comfort-design="comfortDesign"
      :error="error"
      @addedNew="addedNew"
      @input="$emit('input')"
      @search="onSearch"
      @search:blur="$emit('blur')"
      @option:created="optionCreated"
      @option:selected="optionSelected"
      @option:deselected="optionDeselected"
      @option:cleared="optionCleared"
      ref="scroll"
      :style="{ 'width': this.width }"
    >
      <!-- selected option -->
      <div
        slot="selected-option"
        slot-scope="{ option }"
        class="user-selected-option"
        @click="onFocus()"
      >
        <!-- username -->
        <fts-profile
          :user-name="formData[item.fieldName]"
          :user-list="users"
          :profile-photo-size="22"
          profile-group
          :key="formData[item.fieldName]"
          v-if="item.type == 19"
        />
        <!-- users -->
        <template v-else-if="item.type == 21">
          <fts-profile
            :user-name="option.username"
            :user-list="users"
            :profile-photo-size="22"
            v-if="option.username"
          >
            <div slot="profileName" v-if="option.name">
              {{option.name}}
            </div>
          </fts-profile>

          <fts-profile v-else>
            <div slot="profileName">
              {{option.name}}
            </div>
          </fts-profile>
        </template>
        <!-- user -->
        <div v-else-if="!formData[`${item.fieldName}Username`]">
          {{formData[item.fieldName]}}
        </div>
        <fts-profile
          :user-name="formData[`${item.fieldName}Username`]"
          :user-list="users"
          :profile-photo-size="22"
          v-else
        >
          <div slot="profileName" v-if="formData[item.fieldName]">
            {{formData[item.fieldName]}}
          </div>
        </fts-profile>
      </div>
      <!-- option -->
      <template #option="option">
        <fts-profile 
          :profile="item.type == 19 ? option : null"
          :user-name="option.username" 
          :profile-photo-size="22" 
          :user-list="users" 
          :key="option.username"
        >
          <div slot="profileName" slot-scope="{userProfileName, userProfileUsername}" class="fts-user__profile-name">
            <div class="profile-name" v-if="option.optionName == ''">
              <span style="color: gray;">(empty)</span>
            </div>
            <div class="profile-name" v-else-if="option.optionName">{{option.optionName}}</div>
            <div class="profile-name" v-else>{{userProfileName}}</div>
            <div class="profile-username">{{userProfileUsername}}</div>
          </div>
        </fts-profile>
      </template>
    </v-select>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "../vue-select-user/index";

import { classificationStore } from "../store/classificationStore";

import FTSProfile from "../elements/FTSProfile";

export default {
  props: {
    moduleId: [String, Number],
    activityId: String,
    appendToBody: {
      type: Boolean,
      default: true
    },
    additionalFilterKeys: Array,
    reduce: Function,
    reduceKey: String,
    inputId: String,
    multiple: Boolean,
    width: String,
    userList: Array,
    observerHeight: Boolean,
    comfortDesign: Boolean,
    error: Boolean,
    item: Object,
    formData: Object
  },
  components: {
    "v-select": vSelect,
    "fts-profile": FTSProfile,
  },
  data: () => ({
    searchAbortController: null,
    resizeObserver: null,
    list: []
  }),
  computed: {
    label() {
      if (this.userList || this.item.type == 19) {
        return "username";
      } else if (this.item && this.item.connectionId) {
        if (this.item.connectionField === "DocumentId") {
          return "documentId";
        } else if (this.item.connectionField === "Username") {
          return "username";
        } else if (this.item.displayProperty) {
          return this.item.displayProperty;
        } else if (
          this.item.valueTemplate !== null && 
          this.item.valueTemplate !== undefined && 
          this.item.valueTemplate !== ''
        ) {
          return "value";  
        }
        
        return "optionName";
      }

      return "name";
    },
    template: function () {
      if (this.item) return this.item.displayTemplate;
      return "";
    },
    baseServer() {
      return classificationStore.state.baseServer;
    },
    users() {
      return classificationStore.state.users.map((x) => ({
        ...x,
        username: x.username || x.userName
      })).filter((x) =>
        x.disable !== true &&
        x.username !== 'everyone' &&
        x.username !== 'involved'
      );
    },
    getReduceKey() {
      if (this.reduceKey) {
        return this.reduceKey;
      } else if (this.item.reduceKey) {
        return this.item.reduceKey;
      } else if (this.item.type == 19) {
        return "username";
      } else if (this.item.type == 20) {
        if (
          this.item.valueTemplate !== null && 
          this.item.valueTemplate !== undefined && 
          this.item.valueTemplate !== ''
        ) {
          return "value";
        }

        return "optionName";
      }
    },
    getReduce() {
      if (this.reduce && typeof this.reduce === 'function')
        return this.reduce;
      else if (this.item.reduce && typeof this.item.reduce === 'function')
        return this.item.reduce;
      else if (this.getReduceKey)
        return x => x[this.getReduceKey];
      else if (this.item.type == 21)
        return x => ({ id: x.id, name: x.value, username: x.username });
    },
    getOptionLabelKey() {
      if (this.item.type == 21)
        return 'name';
    },
    getModuleId() {
      if (this.moduleId)
        return this.moduleId;
      else if (classificationStore.state.vectorId)
        return classificationStore.state.vectorId;
    },
    getActivityId() {
      if (this.activityId)
        return this.activityId;
      else if (classificationStore.state.activityId)
        return classificationStore.state.activityId;
    },
    getFilterKeys() {
      if (Array.isArray(this.additionalFilterKeys) && this.additionalFilterKeys.length > 0)
        return this.additionalFilterKeys;
      
      if (this.item.type == 19)
        return ["displayName"];

      if (this.item.type == 20 || this.item.type == 21)
        return ["username"];
    },
    isFilterKeys() {
      return Array.isArray(this.getFilterKeys) && this.getFilterKeys.length > 0;
    }
  },
  methods: {
    filterBy(option, label, search) {
      // ref ./vue-select-user/components/Select.vue
      return (label || "").toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    filterByKeys(option, label, search) {
      if (this.filterBy(option, label, search))
        return true;

      return this.getFilterKeys.some(x => this.filterBy(option, option[x], search));
    },
    optionCreated(option) {
    },
    optionSelected(option) {
      if (this.item.type == 19) {
        this.$emit("username", this.formData[this.item.fieldName]);
      } else if (this.item.type == 20) {
        const propertyUsername = `${this.item.fieldName}Username`;
        const propertyId = `${this.item.fieldName}Id`;
        /* username */
        if (option.hasOwnProperty('username'))
          this.$set(this.formData, propertyUsername, option.username);
        else if (this.formData.hasOwnProperty(propertyUsername))
          this.$delete(this.formData, propertyUsername);
        /* username:emit */
        this.$emit("username", this.formData[`${this.item.fieldName}Username`]);
        /* id */
        if (option.hasOwnProperty('id'))
          this.$set(this.formData, propertyId, option.id);
        else if (this.formData.hasOwnProperty(propertyId))
          this.$delete(this.formData, propertyId);
      }
    },
    optionDeselected(option) {
    },
    optionCleared() {
      if (this.item.type == 20) {
        const propertyUsername = `${this.item.fieldName}Username`;
        const propertyId = `${this.item.fieldName}Id`;

        if (this.formData.hasOwnProperty(propertyUsername))
          this.$delete(this.formData, propertyUsername);

        if (this.formData.hasOwnProperty(propertyId))
          this.$delete(this.formData, propertyId);
      }
      this.$emit("username", null);
    },
    onFocus() {
      let input = this.$refs.scroll.$el.querySelector("input");
      input.focus();
    },
    onSearch(search, loading, pageNumber, loadingMore) {
      if (this.$refs.scroll.open) {
        if (this.item.optionList != null) {
          loading = false;
          this.list = this.item.optionList;
        } else if (this.userList) {
          this.list = this.userList;
        } else if (this.item.type == 19) {
          this.list = this.users
        } else {
          if (pageNumber == 0) {
            loading(true);
            this.list = [];
          } else {
            loadingMore(true);
          }
          this.search(loading, search, this, pageNumber, loadingMore);
        }
      }
    },
    search: _.debounce((loading, search, vm, pageNumber, loadingMore) => {
      var dataToPassIn = {},
        lineDataToPassIn = {};
      if (classificationStore) {
        var originalFormData = classificationStore.state.formData;
        if (vm.item.autoCompleteFormDataFields && originalFormData) {
          _.each(vm.item.autoCompleteFormDataFields.split(","), function (
            field
          ) {
            dataToPassIn[field] = originalFormData[field];
            lineDataToPassIn[field] = vm.formData[field];
          });
        } else if (vm.item.filterFormula) {
          dataToPassIn = originalFormData;
          if(originalFormData != vm.formData) {
            lineDataToPassIn = vm.formData;
          }
        }

        var referenceModuleId = null;

        if (vm.item.reference && vm.item.referenceModuleField) {
          loadingMore(false);
          //pass in referene
          referenceModuleId =
            originalFormData[vm.item.referenceModuleField + "Id"];

          if (!referenceModuleId) {
            referenceModuleId =
              vm.formData[vm.item.referenceModuleField + "Id"];
          }
        }
      }

      if (vm.searchAbortController) {
        vm.searchAbortController.abort();
        vm.searchAbortController = null;
      }

      vm.searchAbortController = new AbortController();

      const queryPayload = {
        text: search,
        currentPage: pageNumber,
        pageSize: 10,
        fieldId: vm.item.id,
        x: vm.item.x,
        connectionId: vm.item.connectionId, // source module of the options — selection-cache invalidation tag
        activityId: vm.getActivityId,
        vectorId: vm.getModuleId,
        documentId: classificationStore.state.documentId,
        reference: referenceModuleId,
        locusId: vm.locusId,
        formData: dataToPassIn,
        data: lineDataToPassIn
      };

      classificationStore.dispatch("searchEntry", {
        data: queryPayload, 
        config: { signal: vm.searchAbortController.signal }
      }).then(
        (res) => {
          loading(false);
          loadingMore(false);
          if (pageNumber == 0) {
            if (vm.$refs.scroll && vm.$refs.scroll.numberOfPageLoaded) {
              vm.$refs.scroll.numberOfPageLoaded = 0;
            }
            vm.list = res.data;
          } else {
            vm.list = vm.list.concat(res.data);
          }
        },
        (error) => {
          if (!axios.isCancel(error)) {
            loading(false);
            loadingMore(false);
            console.error(error);
            console.warn(
              "Got nothing from server. Prompt user to check internet connection and try again"
            );
          }
        }
      );
    }, 350),  
    async addedNew(data) {
      try {
        const res = await classificationStore.dispatch("searchEntry", {
          id: data.id,
          vectorId: this.getModuleId,
          activityId: this.getActivityId,
          fieldId: this.item.id,
          x: this.item.x,
          documentId: classificationStore.state.documentId,
          pageSize: 10,
        });
        if (res.data.length == 1) {
          const option = res.data[0];
          this.$set(this.formData, this.item.fieldName, (() => (this.getReduce)(option))());
          this.optionSelected(option);
        }
      } catch(err) {
        console.error(err);
        this.$toasted.global.error({ response: err.response });
      }
    }
  },
  mounted() {
    if (this.item.options) {
      this.list = this.item.optionList;
    }
    if (this.observerHeight && this.multiple) {
      this.resizeObserver = new ResizeObserver(_.debounce(entries => {
        try {
          const entry = entries.find(x => x.target ===this.$el);
          const elOffsetHeight = entry.target.offsetHeight;
          if (elOffsetHeight !== null && elOffsetHeight !== undefined) {
            this.$emit('updateHeight', `${elOffsetHeight}px`);
          }
        } catch(err) {
          console.warn("[DOMException]:ResizeObserver", err);
        }
      })); 
      this.resizeObserver.observe(this.$el);
    }
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.$el);
      this.resizeObserver.disconnect();
    }
  }
};
</script>

<style lang="scss">
.fts-user {
  .user-selected-option {
    min-width: 0;
    .profile-name > div {
      white-space: inherit;
      overflow: inherit;
      text-overflow: inherit;
    }
  }
}
.fts-user__profile-name {
  display: flex;
  align-items: center;
  margin-left: .275rem;
  .profile-username {
    margin-left: .375rem;
    color: var(--fts-default);
  }
}
</style>
